import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var WritingFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.848.223c-.5 0-1 .4-1 1v42c0 .5.4 1 1 1h32.529c.5 0 1-.4 1-1v-10.1c0-.5-.5-1-1-1s-1.001.4-1.001 1v9.1H2.849v-40h30.527v2.2c0 .5.5 1 1 1s1.001-.4 1.001-1v-3.2c0-.5-.4-1-1-1H1.847Zm32.729 10c2.102-2.1 5.605-2.1 7.706 0 2.102 2.1 2.102 5.6-.1 7.6-.302.285-.975.952-1.903 1.88l-7.42-7.42c-.06-.06-.125-.11-.194-.152l1.91-1.908Zm-3.127 3.47 7.42 7.42-2.604 2.615v.001c-4.85 4.87-11.258 11.306-13.978 13.867l-7.597-7.597 6.874-6.776H7.854c-.5 0-1.001-.5-1.001-1s.4-1 1-1h15.714l7.731-7.725c.042.07.092.135.152.194Zm-17.846 17.94-.846 2.79H7.753c-.6 0-1 .5-1 1 0 .6.5 1 1 1h4.304c0 .1-1 3.3-1.1 3.5-.1.4 0 .8.2 1 .2.3.6.4 1.1.3l3.403-1 5.012-1.52-7.068-7.07ZM6.753 8.924c0-.6.5-1 1-1h20.618c.6 0 1.001.5 1.001 1 0 .6-.5 1-1 1H7.853c-.601 0-1.101-.4-1.101-1Z"
  }));
});
WritingFill.displayName = 'WritingFill';
WritingFill.defaultProps = {
  'aria-label': 'WritingFill'
};
export default WritingFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/WritingFill.js
// module id = 3333
// module chunks = 11